import request from '@/utils/request'

let User_infoApi = {

  /*客户资料列表*/
  list(data) {
    return request._post('/shop/plus.user_info.Index/index', data);
},
/*添加客户资料*/
add(data) {
    return request._post('/shop/plus.user_info.Index/add', data);
},
/*修改客户资料*/
edit(data) {
    return request._post('/shop/plus.user_info.Index/edit', data);
},
/*删除客户资料*/
del(data) {
    return request._post('/shop/plus.user_info.Index/del', data);
},
/*客户资料详情*/
detail(data) {
  return request._post('/shop/plus.user_info.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.user_info.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.user_info.Setting/getSetting', data, errorback);
    },
}
export default User_infoApi;



// WEBPACK FOOTER //
// ./src/api/user_info.js